"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mk_pair = void 0;
const mk_pair = (a, b) => ([a, b]);
exports.mk_pair = mk_pair;
